/**
 * Contract display metadata (logo tag + brand colour).
 *
 * TODO(beacon): promote to actual contract columns (`display_tag`,
 * `display_color`) once the contract-edit UI is built. Until then this
 * mapping lives client-side. Falls back to a derived monogram + neutral
 * colour for unknown contracts.
 */

import type { Contract } from '@beacon/core';

interface DisplayMeta {
  tag: string; // 2-letter monogram
  color: string; // hex
}

const META_BY_ID: Record<string, DisplayMeta> = {
  'con-acme': { tag: 'AC', color: '#E57D2F' },
  'con-ironbark': { tag: 'IR', color: '#4C8C5B' },
  'con-vrc': { tag: 'VR', color: '#7A4A9D' },
};

export function contractDisplay(contract: Contract): DisplayMeta {
  const known = META_BY_ID[contract.id];
  if (known) return known;
  return {
    tag: deriveTag(contract.name),
    color: '#4A4F5A', // ink-400 fallback — neutral until colour assigned
  };
}

function deriveTag(name: string): string {
  return (
    name
      .split(/\s+/)
      .map((w) => w[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() || '??'
  );
}
